<div class="c-primary-tabs">
  <div class="tab-level tab-level__0">
    <a *ngFor="let item of data?.items" class="tab-item" [class.active]="data?.selected == item.id"
       (click)="select(item.id)">
      {{item.label}}
    </a>
  </div>

</div>
